export default __webpack_public_path__ + "static/media/work3image1.296e74e8.png";